export default __webpack_public_path__ + "static/media/bitbucket.98e957d5.svg";